












import Vue from 'vue'
import Loader from '@/components/Loader.vue'
import { fileDownload } from '@/helpers'
import { http } from '@/store/http'
import { logUserActivity } from '@/services/AppInsights'

export default Vue.extend({
  name: 'ExportAll',
  components: { Loader },
  data() {
    return {
      isLoading: false,
      hasError: false,
      noReportData: false,
    }
  },
  props: {
    variation: {
      type: String,
      default: '',
    },
    loaderColor: {
      type: String,
      default: '',
    },
    isDailyReplenishmentsEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    accountId(): string {
      return this.$store.state.accountId
    },
  },
  methods: {
    fetchReport() {
      this.isLoading = true
      this.hasError = false
      this.noReportData = false

      // Method to track UserActivity
      logUserActivity('ExportFullReport')

      http
        .get('/api/report', {
          responseType: 'blob',
          params: {
            accountId: this.accountId,
            isDailyReplenishmentsEnabled: this.isDailyReplenishmentsEnabled,
          },
        })
        .then(response => {
          // custom case, successful call if status is 204, but means no report data
          if (response.status === 204) {
            this.noReportData = true
          } else {
            this.download(response)
          }
        })
        .catch(error => {
          this.hasError = true
          console.log(error)
        })
        .finally(() => {
          this.isLoading = false
          if (this.hasError || this.noReportData) {
            setTimeout(() => {
              this.hasError = false
              this.noReportData = false
            }, 3000)
          }
        })
    },
    download(response: any) {
      const date: string = (this as any).$moment().format('MM-DD-YY')
      const disposition: string = response.headers['content-disposition'] || ''
      const mime: string = response.headers['content-type'] || ''
      const filenameMatches = disposition.match(/filename[^;=\n]*="?((['"]).*?\2|[^;"\n]*)"?/)
      const filename = (filenameMatches && filenameMatches[1]) || `vHub-report-${date}.xlsx`

      fileDownload(response.data, filename, mime)
    },
  },
})
